import { canUseGuestLocalWorkspace } from '@affine/component/product-brand';
import { MenuItem } from '@affine/component/ui/menu';
import { AuthService, DefaultServerService } from '@affine/core/modules/cloud';
import { ServerFeature } from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { ImportIcon, PlusIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';

import * as styles from './index.css';

export const AddWorkspace = ({
  onAddWorkspace,
  onNewWorkspace,
}: {
  onAddWorkspace?: () => void;
  onNewWorkspace?: () => void;
}) => {
  const t = useI18n();
  const authService = useService(AuthService);
  const isAuthenticated =
    useLiveData(authService.session.status$) === 'authenticated';
  const defaultServerService = useService(DefaultServerService);
  const serverAllowsLocalWorkspace =
    useLiveData(
      defaultServerService.server.config$.selector(c =>
        c.features.includes(ServerFeature.LocalWorkspace)
      )
    ) ?? false;
  const enableLocalWorkspace =
    BUILD_CONFIG.isNative ||
    (isAuthenticated
      ? serverAllowsLocalWorkspace
      : canUseGuestLocalWorkspace(
          BUILD_CONFIG.isWeb,
          serverAllowsLocalWorkspace
        ));

  return (
    <>
      {BUILD_CONFIG.isElectron && (
        <MenuItem
          block={true}
          prefixIcon={<ImportIcon />}
          prefixIconClassName={styles.prefixIcon}
          onClick={onAddWorkspace}
          data-testid="add-workspace"
          className={styles.ItemContainer}
        >
          <div className={styles.ItemText}>
            {t['com.affine.workspace.local.import']()}
          </div>
        </MenuItem>
      )}
      <MenuItem
        block={true}
        prefixIcon={<PlusIcon />}
        prefixIconClassName={styles.prefixIcon}
        onClick={onNewWorkspace}
        data-testid="new-workspace"
        className={styles.ItemContainer}
      >
        <div className={styles.ItemText}>
          {enableLocalWorkspace
            ? t['com.affine.workspaceList.addWorkspace.create']()
            : t['com.affine.workspaceList.addWorkspace.create-cloud']()}
        </div>
      </MenuItem>
    </>
  );
};
